/**
 * Generates core brand data in the format expected by the backend API
 * Converts TreeSelect selections into structured data with brand/subbrand relationships
 * Used for saving core brand configurations to the server
 *
 * @param {string} customName - Custom display name for the core brand group
 * @param {string[]} selectedBrands - Array of selected brand/subbrand value strings
 * @returns {object} Structured data object with name and content array for API submission
 *
 * @example
 * const data = generateCoreBrandData("My Brands", ["Coca Cola", "Pepsi_Pepsi Max"]);
 * // Returns: { name: "My Brands", content: [{ brand: "Coca Cola", subbrand: null }, { brand: "Pepsi", subbrand: "Pepsi Max" }] }
 */
export const generateCoreBrandData = (
	customName: string,
	selectedBrands: string[],
	brandOptions: any[]
) => {
	const content: Array<{ brand: string; subbrand: string | null }> = [];

	if (selectedBrands && selectedBrands.length > 0) {
		selectedBrands.forEach((selectedValue) => {
			// A selected value matches either a brand node or one of its subbrand children.
			(brandOptions as any[]).forEach((brand: any) => {
				if (brand.value === selectedValue) {
					content.push({
						brand: brand.title,
						subbrand: null, // brand-level selection, so no subbrand
					});
				}
				else if (brand.children) {
					const foundSubbrand = brand.children.find(
						(subbrand: any) => subbrand.value === selectedValue
					);
					if (foundSubbrand) {
						content.push({
							brand: brand.title,
							subbrand: foundSubbrand.title,
						});
					}
				}
			});
		});
	}

	const result = {
		name: customName || "",
		content: content,
	};

	console.log("[generateCoreBrandData] Generated data:", result);
	return result;
};
